import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	DishFullInfoContext,
	IDishFullInfoContext,
} from '../../../../../../../../../dishFullInfoState/dishFullInfoContext';
import style from './SubCategoriesField.module.scss';

const SubCategoriesField: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	return (
		<div className={style.container}>
			<Text translationNameSpace="form" translationKey="subcategoriesLabel" theme="neutralLight" size="xs" />
			<div className={style.subCategoriesList}>
				{dishForFullInfo?.allSubCategories.length
					? dishForFullInfo.allSubCategories.map((el) => {
							return (
								<div key={el.id} className={style.item}>
									<div className={style.dot} />
									<Text translationKey={el.subCategoryName} size="s" withTooltip={true} />
								</div>
							);
					  })
					: '-'}
			</div>
		</div>
	);
};

export default SubCategoriesField;
